export default __webpack_public_path__ + "static/media/Quantico-Regular.9d0882b9.ttf";